module.exports = __webpack_public_path__ + "img/ch07_09_水果糖.d87c4d33.jpg";